function removeHtmlComments(input) {
    // 用 DOMParser 解析 HTML，保证结构正确
    const parser = new DOMParser();
    const doc = parser.parseFromString(input, 'text/html');

    // 先取 body 内部内容，如果没有 body，就用整个文档
    let output = (doc.body && doc.body.innerHTML) || input;

    // 1. 去掉条件注释 <!--[if ...]> ... <![endif]-->
    output = output.replace(/<!--\[if[\s\S]*?<!\[endif\]-->/gi, '');

    // 2. 去掉普通 HTML 注释
    output = output.replace(/<!--[\s\S]*?-->/gi, '');

    // 3. 去掉 Word 的命名空间标签 (o:, v:, w:, m:)
    output = output.replace(/<\/?(o|v|w|m):[^>]*>/gi, '');

    // 4. 去掉 <meta> <link> <style> <script> <head> <title>
    output = output.replace(/<(?:style|script|head|title)[\s\S]*?<\/(?:style|script|head|title)>/gi, '')

    return output.trim();
}


// function replaceEmptyPTagsWithBr(html) {
//     return html.replace(/<p\b[^>]*>(\s|&nbsp;|<span\b[^>]*>\s*<\/span>)*<\/p>/gi, '<br>');
// }

function replaceEmptyPTagsWithBr(html) {
    return html.replace(
        /<p\b[^>]*>(?:\s|&nbsp;|<span\b[^>]*>(?:\s|&nbsp;|<\/?span[^>]*>)*<\/span>)*<\/p>/gi,
        '<br>'
    );
}

function replaceLineBreaksWithEmptyP(html) {
    console.log(hasCustomTag(html),'hasCustomTag(html)')
    if (hasCustomTag(html)) {
        return html.trim().replace(/(\r\n|\r|\n){2,}/g, (match) => {
            // match.length / 2 近似得到换行次数（\r\n算两个字符）
            const count = match.split(/(\r\n|\r|\n)/).filter(Boolean).length;
            // 至少保留两个 <br>，每多一个换行加一个 <br>
            return "<br>".repeat(count);
        });
    } else {
        return html
            .replace(/^\r\n|\r\n$/g, '')           // 去除首尾换行
            .replace(/\r\n/g, '<br>');             // 替换中间的换行
    }
}

// 判断是否有 自定义的邮箱标签
function hasCustomTag(html) {
    // 匹配所有尖括号包裹的内容
    const tagRegex = /<([^\s>\/]+)[^>]*>/g;
    let match;

    while ((match = tagRegex.exec(html)) !== null) {
        const tagName = match[1];
        if (tagName.includes('@')) {
            return true; // 找到含 @ 的标签名
        }
    }
    return false;
}

function replaceBrToP(html) {
    // return html.replace(/<br\s*\/?>/gi, '<p class="tiny_edit_br_simulation_p">&nbsp;</p>');
    if (!html) return html;

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    function processNode(node) {
        if (!node || !node.childNodes) return;

        [...node.childNodes].forEach(child => {
            // 只处理 <br>
            if (child.nodeName.toLowerCase() === "br") {
                // 判断 <br> 是否处于 table/thead/tbody/tr/td/th 内部
                let inTableContext = false;
                let parent = child.parentNode;
                while (parent) {
                    const tag = parent.nodeName.toLowerCase();
                    if (["table", "thead", "tbody", "tr", "td", "th"].includes(tag)) {
                        inTableContext = true;
                        break;
                    }
                    parent = parent.parentNode;
                }

                if (!inTableContext) {
                    // 替换为 <p class="tiny_edit_br_simulation_p">&nbsp;</p>
                    const p = doc.createElement("p");
                    p.className = "tiny_edit_br_simulation_p";
                    p.innerHTML = " ";
                    child.replaceWith(p);
                }
            } else {
                // 递归处理
                processNode(child);
            }
        });
    }

    processNode(doc.body);

    return doc.body.innerHTML;
}

/**
 * 等待渲染完毕后，定位光标到第一个文本节点，并提取其字体
 * @param {Editor} editor - TinyMCE 编辑器实例
 * @param {Function} onFontDetected - 检测到字体后回调 (fontFamily: string) => void
 */
function locateCursorAndDetectFont(editor, onFontDetected) {
    requestAnimationFrame(() => {
        setTimeout(() => {
            const textNode = getFirstTextNode(editor);
            if (textNode) {
                // 设置光标到该节点
                const rng = editor.dom.createRng();
                rng.setStart(textNode, 0);
                rng.setEnd(textNode, 0);
                editor.selection.setRng(rng);
                editor.focus();

                // 获取有效字体（向上查找第一个 computed font-family）
                let node = textNode.parentNode;
                while (node && node !== editor.getBody()) {
                    const computedFont = window.getComputedStyle(node).fontFamily;
                    if (computedFont && computedFont !== '') {
                        console.log('最终字体：', computedFont);
                        onFontDetected?.(computedFont);
                        return;
                    }
                    node = node.parentNode;
                }

                // 若未找到字体
                console.warn('未找到字体样式');
                onFontDetected?.('');
            } else {
                console.warn('未找到文本节点');
                onFontDetected?.('');
            }
        }, 50); // 延迟确保 DOM 样式已应用
    });
}

/**
 * 获取正文中第一个非空文本节点
 * @param {Editor} editor
 * @returns {Text|null}
 */
function getFirstTextNode(editor) {
    function findTextNode(node) {
        if (!node) return null;

        if (node.nodeType === 3 && node.nodeValue.trim() !== '') {
            return node;
        }

        if (node.nodeType === 1 && node.hasChildNodes()) {
            for (let i = 0; i < node.childNodes.length; i++) {
                const found = findTextNode(node.childNodes[i]);
                if (found) return found;
            }
        }

        return null;
    }

    const body = editor.getBody();
    return findTextNode(body);
}


// 对空白行 进行默认字体处理

function changeBlankLine(editor, defaultFont) {
    // 更新空白行字体样式
    const blocks = editor.getBody().querySelectorAll('p, div, span');

    blocks.forEach(node => {
        const text = node.textContent?.trim();
        const innerHtml = node.innerHTML.trim().toLowerCase();

        const isEmptyText = !text;
        const isOnlyBr = innerHtml === '<br>' || innerHtml === '';
        const isOnlyEmptySpan = /^<span[^>]*><\/span>$/.test(innerHtml);
        const shouldUpdateFont =
            (isEmptyText || isOnlyBr || isOnlyEmptySpan) &&
            node.style?.fontFamily !== defaultFont;

        if (shouldUpdateFont) {
            editor.dom.setStyle(node, 'font-family', defaultFont);
        }

        // 清理 span 的 font-family，如果它是空的
        if (node.tagName === 'SPAN' && node.style?.fontFamily) {
            const spanText = node.textContent?.trim();
            if (!spanText) {
                node.style.fontFamily = '';
                if (node.getAttribute('style') === '') {
                    node.removeAttribute('style');
                }
            }
        }
    });
}

const changeFirstLine = (html) => {
    const container = document.createElement('div');
    container.innerHTML = html;

    const firstNode = container.querySelector('p, div, span');
    if (!firstNode) return html; // 找不到，返回原html

    function getDeepestElement(node) {
        if (!node.children || node.children.length === 0) return node;
        return getDeepestElement(node.children[0]);
    }

    const deepest = getDeepestElement(firstNode);

    const computedFont = window.getComputedStyle(deepest).fontFamily || deepest.style.fontFamily;
    if (computedFont) {
        firstNode.style.fontFamily = computedFont;
    }

    return container.innerHTML;
};


/*
暂时删除了 ol
 */
const resetCss = `<style>
div, p, span, li, dl, dt, dd,
h1, h2, h3, h4, h5, h6,
form, input, textarea, button, select,
img, a {
      margin: 0;
      padding: 0;
      font-size: 14px !important;
      box-sizing: border-box;
}
table, tr, td, th{
      margin: 0;
      padding: 0;
      font-size: 14px !important;
      box-sizing: border-box;
}
ol{
    margin-top: 1em !important;
    margin-bottom: 1em !important;
    padding-bottom: 0 !important;
    font-size: 14px !important;
    box-sizing: border-box;
}
ul{
    margin-top: 1em !important;
    margin-bottom: 1em !important;
    padding-bottom: 0 !important;
    font-size: 14px !important;
    box-sizing: border-box;
}
</style>`

export {
    resetCss,
    removeHtmlComments,
    replaceEmptyPTagsWithBr,
    replaceLineBreaksWithEmptyP,
    replaceBrToP,
    locateCursorAndDetectFont,
    changeFirstLine,
    changeBlankLine,
}